
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const appApi = createApi({
  reducerPath: 'api',
  tagTypes: ['Child', 'Duplicates', 'DuplicateThreshold'],
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_SERVER_URL ?? ''}` }),
  endpoints: (builder) => ({
  })
})
